export const ALL = 'all';

export enum CategoryAllTasks {
  Id = 'all',
  Name = '$.ALL_TASKS',
  Icon = 'all-tasks',
}
